<template>
  <div>
    <v-card style="max-width: 400px; min-width: 300px; margin: auto">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card color="#efefef" class="back--text">
            <v-layout row p1-2>
              <v-flex xs9>
                <v-card-title primary-title>
                  <div class="member_name">
                    <div>{{ task.name }}</div>
                    <span class="caption">{{ task.uc ? task.uc.id : "" }}</span>
                  </div>
                </v-card-title>
              </v-flex>
              <v-flex xs3 pt-3>
                <v-avatar :tile="false" size="46" color="grey lighten-4">
                  <v-img class="elevation-6" :src="avatar"></v-img>
                </v-avatar>
              </v-flex>
            </v-layout>
            <v-divider light></v-divider>
            <v-card-text class="pa-1">
              <v-layout align-center justify-end row fill-height pl-3 pr-2>
                <div>
                  <span>{{
                    task.saved_at || task.signedcontract_at | formatarDate
                  }}</span>
                </div>
                <v-spacer />
                <v-btn
                  small
                  round
                  dark
                  :color="
                    task.uc ? task.uc.status : task.status | formatUCStatusColor
                  "
                  v-if="showStatus"
                  style="height: 19px; font-size: 10px"
                >
                  {{ task.uc ? task.uc.status : task.status | formatUCStatus }}
                </v-btn>
              </v-layout>
              <v-flex sm12 md12>
                <v-layout align-center justify-end row fill-height pr-2>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }" pa-2>
                      <v-btn
                        icon
                        small
                        round
                        dark
                        color="#efefef"
                        style="margin: 0px 2px"
                        @click="doCopy(task.email)"
                        v-on="on"
                      >
                        <v-icon color="black">mail_outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ task.email }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        round
                        dark
                        color="#efefef"
                        style="margin: 0px 2px"
                        :href="`https://api.whatsapp.com/send?phone=${phone}`"
                        v-on="on"
                      >
                        <v-icon color="green darken-3">mdi-whatsapp</v-icon>
                      </v-btn>
                    </template>
                    <span>Enviar whatsapp para {{ task.phone }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template
                      v-slot:activator="{ on }"
                      v-if="task.uc && task.uc.contract_id"
                    >
                      <v-btn
                        icon
                        small
                        round
                        dark
                        color="#efefef"
                        style="margin: 0px 2px"
                        :href="
                          'https://painel.autentique.com.br/documentos/' +
                          task.uc.contract_id
                        "
                        target="_blank"
                        v-on="on"
                      >
                        <v-icon
                          :color="
                            typeof task.uc.contract_id === 'object'
                              ? 'red'
                              : '#000'
                          "
                          >history_edu</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Ver contrato</span>
                  </v-tooltip>
                  <v-spacer />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        round
                        dark
                        color="#d0d0d0"
                        style="margin: 0px 2px"
                        @click="showDocumentModal(task)"
                        target="_blank"
                        v-on="on"
                      >
                        <v-icon color="black">mdi-file-document-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Documentos do membro</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="task.uc">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        round
                        dark
                        color="#d0d0d0"
                        style="margin: 0px 2px"
                        @click="editConsumerUnit(task.uc)"
                        target="_blank"
                        v-on="on"
                      >
                        <v-icon color="black">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Unidade Consumidora</span>
                  </v-tooltip>
                  <!-- <v-tooltip bottom v-if="task.huggy_id">
                          <template v-slot:activator="{ on }">
                            <v-btn icon small round dark  color="#d0d0d0" style=" margin: 0px 2px"
                              :href="'https://www.huggy.app/panel/contacts/'+ task.huggy_id"
                              target="_blank"
                              v-on="on"
                            >
                                <v-icon color="black">filter_list</v-icon>
                            </v-btn>
                          </template>
                          <span>Chamar no Huggy</span>
                        </v-tooltip> -->
                  <v-tooltip
                    bottom
                    v-if="
                      task.uc &&
                      (!task.uc.contract_id ||
                        task.uc.contract_id === '' ||
                        typeof task.uc.contract_id === 'object')
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        round
                        dark
                        color="#d0d0d0"
                        style="margin: 0px 2px"
                        @click="newContract(task, task.uc)"
                        v-on="on"
                      >
                        <v-icon color="black">history_edu</v-icon>
                      </v-btn>
                    </template>
                    <span>Gerar Contrato</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        round
                        dark
                        color="#d0d0d0"
                        style="margin: 0px 2px"
                        @click="
                          task.uc
                            ? goToCustomerCareByUC(task.uc.id)
                            : goToCustomerCareByUser(task.email)
                        "
                        v-on="on"
                      >
                        <v-icon color="black">settings_accessibility</v-icon>
                      </v-btn>
                    </template>
                    <span>Ir para tela de atendimento</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-snackbar
          :color="snack.color"
          :bottom="snack.bottom"
          :top="snack.top"
          :left="snack.left"
          :right="snack.right"
          v-model="snack.snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ snack.snackMessage }}</div>
          <v-icon size="16" @click="snack.snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-layout>
    </v-card>
    <DocumentModal ref="documentModal" />
  </div>
</template>

<script>
import { eventBus } from "../../../main";
import { createContract } from "../../../services/autentique";
import { saveAnalytics } from "../../../services/save_analytics";
import { clearPhone } from "../../../utils/utils";
import DocumentModal from "./DocumentModal.vue";

export default {
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    showStatus: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: () => false,
    },
  },
  components: { DocumentModal },
  computed: {
    badgeColor() {
      const mappings = {
        Design: "purple",
        "Feature Request": "teal",
        Backend: "blue",
        QA: "green",
        default: "teal",
      };
      return mappings[this.task.type] || mappings.default;
    },
    avatar() {
      if (this.task.gender === "M") {
        return "https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light";
      } else {
        return "https://avataaars.io/";
      }
    },
    phone() {
      return clearPhone(this.task.phone);
    },
  },
  data: function () {
    return {
      loading: false,
      loading_contract: false,
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
    };
  },
  methods: {
    setAction: function (type, object) {
      if (type === "subscriptions") this.editLead(object);
    },
    editLead: function (lead) {
      this.loading = true;
      // console.log('lead1: ', newLead)
      eventBus.$emit("Lead", lead);
      this.loading = false;
      eventBus.$emit("dialog", true); // emit the event to the bus
    },
    editConsumerUnit: function (cosumerUnit) {
      this.loading = true;
      eventBus.$emit("consumerunit", {
        type: "edit",
        data: cosumerUnit,
        readonly: true,
      });
      this.loading = false;
      eventBus.$emit("dialog_consumer_unit", true); // emit the event to the bus
    },
    doCopy: function (obj) {
      this.$copyText(obj).then(
        function () {
          // this.show_snack('Copiado para a memoria!','success','top')
          alert("Copiado para a memoria!");
        },
        function () {
          // this.show_snack('Erro ao copiar para a memória!','error','top')
          alert("Erro ao copiar para a memória!");
        },
      );
    },
    goToCustomerCareByUC(uc) {
      this.$router.push({ path: "/atendimento/?installation_number=" + uc });
    },
    goToCustomerCareByUser(email) {
      this.$router.push({ path: "/atendimento/?email=" + email });
    },
    async newContract(user, consumerunit) {
      this.loading_contract = true;
      let data = {
        name: consumerunit.name,
        email: user.email,
        cpf: consumerunit.cpf || user.cpf,
        rg: user.ID_document,
        uc: consumerunit.installation_number,
        percentage: consumerunit.percentage,
        percentage_discount: consumerunit.percentage_discount,
        payment_type: user.payment_type,
        address: consumerunit.address,
        creditos: consumerunit.creditos,
        nationality: user.nationality || "Brasileiro(a)",
        phone: user.phone,
        concessionaria: "Cemig",
        tempo_contrato: "3(três) meses",
      };
      if (!data.name || data.name === "") {
        this.show_snack(
          "O nome do membro é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      } else if (!data.email || data.email === "") {
        this.show_snack(
          "O e-mail do membro é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      } else if (!data.cpf || data.cpf === "") {
        this.show_snack(
          "O CPF do membro é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      } else if (!data.rg || data.rg === "") {
        this.show_snack(
          "O documento do membro é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      } else if (!data.uc || data.uc === "") {
        this.show_snack(
          "A unidade consumidora é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      } else if (!data.percentage || Number(data.percentage) <= 0) {
        this.show_snack(
          "O percentual é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      } else if (
        !data.percentage_discount ||
        Number(data.percentage_discount) <= 0
      ) {
        this.show_snack(
          "O percentual de desconto é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      } else if (!data.phone || data.phone === "") {
        this.show_snack(
          "O telefone é obrigatório para geração do contrato!",
          "error",
          "top",
        );
        this.loading_contract = false;
        return;
      }
      console.log("createContract: ", data);
      createContract(data)
        .then((res) => {
          if (res.status === 200) {
            consumerunit.contract_id = res.data.data.createDocument.id;
            this.loading_contract = false;
            this.show_snack(
              "Contrato gerado com sucesso com sucesso!",
              "success",
              "top",
            );
            const analytics = {
              eventCategory: "SUPER",
              eventAction: "CONTRATO-GERADO",
              eventLabel: this.currentUser.partner_id || "enercred",
              utm_source: "SUPER",
              utm_medium: this.signedcontract_by || "",
              utm_campaign: this.currentUser.email,
              boleto: false,
              uc: data.uc,
            };
            saveAnalytics(analytics);
          } else {
            this.loading_contract = false;
            this.show_snack("Erro ao gerar contrato!" + res, "error", "top");
            console.error(res);
          }
        })
        .catch((error) => {
          this.loading_contract = false;
          this.show_snack("Erro ao gerar contrato!", "error", "top");
          console.error(error);
        });
    },
    show_snack(message, color, ...args) {
      this.snack.top = false;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
    showDocumentModal(customer) {
      this.$refs.documentModal.showDocumentModal(customer);
    },
  },
};
</script>
<style scoped>
.member_name {
  font-weight: 400;
}
</style>
